// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-white: #fff;
    --primary-black: #000;
    --primary-grey: #73739a;
    --primary-blue: #6d72f6;
    --primary-green: #08ce8a;
    --primary-black2: #1c1c57;
}

.Contact-section{
    padding: 2rem 20px;
}

.Contact-main-container{
    width: 100%;
    height: 100%;
    display: flex;
    margin: 0 auto;
    overflow: hidden;
    max-width: 1200px;
    border-radius: 30px;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.Contact-top-container{
    gap: 20px;
    display: flex;
    padding: 40px 3rem;
}

.Contact-left-container{
    flex: 1 1 100%;
}

.Contact-left-title-box h1{
    font-size: 30px;
    margin-bottom: 20px;
    color: var(--primary-black2);
}

.Contact-left-title-box p{
    font-size: 18px;
    color: var(--primary-grey);
}

.Contact-left-img-box{
    display: flex;
    margin-top: 30px;
    align-items: center;
    justify-content: center;
}

.Contact-left-img-box img{
    width: 100%;
    max-width: 450px;
}

.Contact-right-container{
    flex: 1 1 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Contact-right-container form{
    gap: 20px;
    width: 100%;
    display: flex;
    max-width: 420px;
    flex-direction: column;
}

.Contact-right-container form input,
.Contact-right-container form textarea{
    outline: none;
    padding: 14px 20px;
    border-radius: 22px;
    border: 1px solid #f1f1f1;
    box-shadow: 0px 2px 6px rgb(0, 0, 0, 0.1);
}

.Contact-right-container form textarea{
    height: 140px;
    resize: none;
}

.Contact-right-container form button{
    width: 100%;
    border: none;
    overflow: none;
    font-size: 16px;
    cursor: pointer;
    padding: 16px 10px;
    border-radius: 12px;
    transition: 0.3s linear;
    color: var(--primary-white);
    background-color: var(--primary-blue);
}

.Contact-right-container form button:hover {
    transform: translateY(-5px);
    background-color: #555ae6;
    box-shadow: 1px 1px 10px #6d72f6;
}

.Contact-bottom-container{
    gap: 20px;
    display: flex;
    padding: 2rem;
    align-items: center;
    justify-content: space-evenly;
    background: linear-gradient(90deg, #6d72f6, #a869f0);
}

.Contact-bottom-box{
    gap: 12px;
    display: flex;
    align-items: center;
}

.Contact-bottom-icon-box {
    width: 80px;
    height: 80px;
    font-size: 3rem;
    display: flex;
    margin: 3px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    color: var(--primary-white);
    border: 1px solid #fff;
}

.Contact-bottom-title-box h2 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: var(--primary-white);
}

.Contact-bottom-title-box p {
    font-size: 1rem;
    color: var(--primary-white);
}
`, "",{"version":3,"sources":["webpack://./src/Components/Contact/Contact.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,oDAAoD;AACxD;;AAEA;IACI,SAAS;IACT,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B","sourcesContent":[":root {\n    --primary-white: #fff;\n    --primary-black: #000;\n    --primary-grey: #73739a;\n    --primary-blue: #6d72f6;\n    --primary-green: #08ce8a;\n    --primary-black2: #1c1c57;\n}\n\n.Contact-section{\n    padding: 2rem 20px;\n}\n\n.Contact-main-container{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    margin: 0 auto;\n    overflow: hidden;\n    max-width: 1200px;\n    border-radius: 30px;\n    flex-direction: column;\n    justify-content: space-between;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n}\n\n.Contact-top-container{\n    gap: 20px;\n    display: flex;\n    padding: 40px 3rem;\n}\n\n.Contact-left-container{\n    flex: 1 1 100%;\n}\n\n.Contact-left-title-box h1{\n    font-size: 30px;\n    margin-bottom: 20px;\n    color: var(--primary-black2);\n}\n\n.Contact-left-title-box p{\n    font-size: 18px;\n    color: var(--primary-grey);\n}\n\n.Contact-left-img-box{\n    display: flex;\n    margin-top: 30px;\n    align-items: center;\n    justify-content: center;\n}\n\n.Contact-left-img-box img{\n    width: 100%;\n    max-width: 450px;\n}\n\n.Contact-right-container{\n    flex: 1 1 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.Contact-right-container form{\n    gap: 20px;\n    width: 100%;\n    display: flex;\n    max-width: 420px;\n    flex-direction: column;\n}\n\n.Contact-right-container form input,\n.Contact-right-container form textarea{\n    outline: none;\n    padding: 14px 20px;\n    border-radius: 22px;\n    border: 1px solid #f1f1f1;\n    box-shadow: 0px 2px 6px rgb(0, 0, 0, 0.1);\n}\n\n.Contact-right-container form textarea{\n    height: 140px;\n    resize: none;\n}\n\n.Contact-right-container form button{\n    width: 100%;\n    border: none;\n    overflow: none;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 16px 10px;\n    border-radius: 12px;\n    transition: 0.3s linear;\n    color: var(--primary-white);\n    background-color: var(--primary-blue);\n}\n\n.Contact-right-container form button:hover {\n    transform: translateY(-5px);\n    background-color: #555ae6;\n    box-shadow: 1px 1px 10px #6d72f6;\n}\n\n.Contact-bottom-container{\n    gap: 20px;\n    display: flex;\n    padding: 2rem;\n    align-items: center;\n    justify-content: space-evenly;\n    background: linear-gradient(90deg, #6d72f6, #a869f0);\n}\n\n.Contact-bottom-box{\n    gap: 12px;\n    display: flex;\n    align-items: center;\n}\n\n.Contact-bottom-icon-box {\n    width: 80px;\n    height: 80px;\n    font-size: 3rem;\n    display: flex;\n    margin: 3px;\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center;\n    color: var(--primary-white);\n    border: 1px solid #fff;\n}\n\n.Contact-bottom-title-box h2 {\n    font-size: 1.2rem;\n    margin-bottom: 0.5rem;\n    color: var(--primary-white);\n}\n\n.Contact-bottom-title-box p {\n    font-size: 1rem;\n    color: var(--primary-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
